import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as Styles from './ModalBlockedPopup.styles';
import desktopImage from '@/media/modal-blocked-popup/studio-blocked-popup-desktop.png';
import mobileImage from '@/media/modal-blocked-popup/studio-blocked-popup-mobile.png';
import { useResize } from '@/hooks/useResize';
import { POPUP_BLOCKED_ORIGIN } from '../../useBlockedWindowModal.enum';
import { sitesActions } from '@/redux/modules';
import { useDispatch, useSelector } from 'react-redux';

const ModalBlockedPopup = ({ onClose, origin = POPUP_BLOCKED_ORIGIN.DEFAULT }) => {
  const { sites: sitesLocale } = useLocale();
  const sitesReducer = useSelector(state => state.sites);

  const builderSsoState = sitesReducer.sitebuilder.sso;

  const dispatch = useDispatch();

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width <= 900;

  const blockedPopupLocale = sitesLocale.modalBlockedPopup[origin];

  const handleClose = () => {
    onClose && onClose();
  };

  const handleOpenHgBuilder = () => {
    if (builderSsoState.url) {
      window.open(builderSsoState.url, '_blank');
      handleClose();
      return;
    }

    if (!builderSsoState.builderAddonId || !builderSsoState.domain) {
      handleClose();
      return;
    }

    dispatch(sitesActions.builderSso.request({ builderAddonId: builderSsoState.builderAddonId, domain: builderSsoState.domain, callback: handleClose }));
  };

  const buttonCta = () => {
    const rules = {
      [POPUP_BLOCKED_ORIGIN.DEFAULT]: handleClose,
      [POPUP_BLOCKED_ORIGIN.SITE_CREATED_WITH_HG_BUILDER]: handleOpenHgBuilder,
      [POPUP_BLOCKED_ORIGIN.OPEN_HG_BUILDER_EDITOR]: handleOpenHgBuilder,
    };

    return origin ? rules[origin]() : handleClose();
  };

  return (
    <Modal
      testId="modal-blocked-popup"
      maxWidth={800}
      onClose={onClose}
    >
      <Styles.Wrapper>
        <Styles.Image src={mobile ? mobileImage : desktopImage} />

        <Styles.Title>{blockedPopupLocale.title}</Styles.Title>
        <Styles.Description>{blockedPopupLocale.description}</Styles.Description>

        <Button
          testId="modal-blocked-popup-close-button"
          label={blockedPopupLocale.buttonLabel}
          onClick={buttonCta}
          size="large"
          width={mobile ? 'full' : 'fit'}
          loading={builderSsoState.loading}
          disabled={builderSsoState.loading}
        />
      </Styles.Wrapper>
    </Modal>
  );
};

export default ModalBlockedPopup;
